module.exports = __webpack_public_path__ + "img/rfq.63a22d68.svg";